import React from "react";
import { Box, Typography, Button, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const style = (theme) => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(6),
    display: "flex",
    justifyContent: "center",
  },
  box: {
    width: "70%",
  },
});

const useStyles = makeStyles(style);

export default function RefreshTableComponent({ handleReload }) {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.root}>
      <Box className={classes.box}>
        <Typography
          variant="body2"
          color="primary"
          style={{ fontWeight: "bold", paddingBottom: "16px" }}
        >
          No data received
        </Typography>
        <Typography
          variant="body2"
          style={{ color: "#9CA6A9", paddingBottom: "16px" }}
        >
          Something went wrong
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleReload}
          disableElevation
        >
          Refresh Page
        </Button>
      </Box>
    </Paper>
  );
}
